"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.vehicleImagePropType = exports.productTilePropType = exports.dataPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = require("@mmc/text");
var vehicleImagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});
exports.vehicleImagePropType = vehicleImagePropType;
var productTilePropType = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  vehicleImage: vehicleImagePropType,
  name: _propTypes["default"].string
}));
exports.productTilePropType = productTilePropType;
var dataPropType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  productTile: productTilePropType,
  addPriceDisclaimer: _propTypes["default"].bool,
  priceDisclaimerId: _propTypes["default"].string,
  disclaimerData: _text.disclaimerDataPropTypes
});
exports.dataPropType = dataPropType;